// extracted by mini-css-extract-plugin
module.exports = {"confettiColors":"#fc5aa6,#fc4198,#26252a,#4a4455,silver","childWrapper":"Confetti_childWrapper__1mgHc","confettiHolder":"Confetti_confettiHolder__3HsCy"};